import * as React from "react";

const JobContext = React.createContext(null);

export default JobContext;
